/**
 * Scroll reveal. Adds `is-revealed` to every `[data-reveal]` element once it
 * enters the viewport; assets/critical.css does the fade-up (text) and the
 * trim-path draw (`data-reveal="line"`). Elements revealed in the same frame
 * are staggered top-to-bottom through `--reveal-delay`. Anything already
 * scrolled past on load is revealed at once, and so is everything when the
 * visitor prefers reduced motion or IntersectionObserver is missing.
 * Re-scans a section when the theme editor re-renders it, and any element that
 * dispatches a bubbling `reveal:scan` event after appending content (the blog's
 * "Load more").
 */
(function () {
  const SELECTOR = '[data-reveal]:not(.is-revealed)';
  const STAGGER_MS = 90;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer = null;

  function reveal(el, index) {
    el.style.setProperty('--reveal-delay', index * STAGGER_MS + 'ms');
    el.classList.add('is-revealed');
  }

  function revealAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach((el) => reveal(el, 0));
  }

  function onIntersect(entries) {
    const due = entries.filter((entry) => entry.isIntersecting || entry.boundingClientRect.bottom < 0);
    due.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    due.forEach((entry, i) => {
      observer.unobserve(entry.target);
      reveal(entry.target, entry.isIntersecting ? i : 0);
    });
  }

  function scan(root) {
    if (!observer) {
      revealAll(root);
      return;
    }
    (root || document).querySelectorAll(SELECTOR).forEach((el) => observer.observe(el));
  }

  function setup() {
    if (observer) observer.disconnect();
    observer = null;
    if (motion.matches || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }
    observer = new IntersectionObserver(onIntersect, { threshold: 0.15 });
    scan();
  }

  setup();
  motion.addEventListener('change', setup);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('reveal:scan', (event) => scan(event.target));
})();
